

import React, { memo } from 'react';
import AutosizeInput from 'react-input-autosize';
import LabelWrapper from '../LabelWrapper';
import Button from '../Button';
import Icon from '../Icon';
import './styles/_input-number.scss';












function isValueValid({ value, min, max }) {
  const isMinANumber = typeof min === 'number';
  const isMaxANumber = typeof max === 'number';

  if (!isMinANumber && !isMaxANumber) {
    return true;
  }

  if (isMinANumber && !isMaxANumber) {
    return value >= min;
  }

  if (!isMinANumber && isMaxANumber) {
    return value <= max;
  }

  return value <= max && value >= min;
}

function onClick(onChangeNumber, value, { increment, max, min }) {
  return () => {
    const calculatedVal = increment ? 1 : -1;
    const newValue = value + calculatedVal;

    if (!isValueValid({ value: newValue, min, max })) {return;}

    onChangeNumber(newValue);
  };
}

function onChange(onChangeNumber, { min, max }) {
  return ({ target: { value } }) => {
    const numberValue = Number(value) || 0;

    if (!isValueValid({ value: numberValue, min, max })) {return;}

    onChangeNumber(numberValue);
  };
}

function sanitiseInput(e) {
  const { key } = e;

  if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(key) || !Number.isNaN(Number(key))) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();
}

function InputNumber({
  value = 0,
  onChangeNumber,
  disabled,
  label,
  min,
  max,
  labelProps
}) {
  return (
    <LabelWrapper {...labelProps} divContainer className="input-number__label-wrapper" label={label}>
      <div className="input-number">
        <div className="input-number__text">
          <AutosizeInput
            className="text input-number__text__value"
            value={value}
            onChange={onChange(onChangeNumber, { min, max })}
            onKeyDown={sanitiseInput}
            disabled={disabled} />

          <div className="input-number__arrows">
            <Button
              type="TERTIARY"
              className="input-number__arrow-btn"
              onClick={onClick(onChangeNumber, value, { min, max, increment: true })}
              prefix={<Icon name="arrowup" size={8} />}
              disabled={disabled} />

            <Button
              type="TERTIARY"
              className="input-number__arrow-btn"
              onClick={onClick(onChangeNumber, value, { min, max })}
              prefix={<Icon name="arrowdown" size={8} />}
              disabled={disabled} />

          </div>
        </div>
      </div>
    </LabelWrapper>);

}

export default memo(InputNumber);